module.exports = ".kan-mails-container {\n  height: 100%;\n  width: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-flow: column;\n          flex-flow: column; }\n  .kan-mails-container .kan-mails-actions {\n    padding: 0 30px;\n    font-size: 13px;\n    min-height: 55px; }\n  @media screen and (max-width: 450px) {\n      .kan-mails-container .kan-mails-actions {\n        padding: 0; } }\n"


//////////////////
// WEBPACK FOOTER
// ./src/modules/mails/components/mails/component.scss
// module id = ./src/modules/mails/components/mails/component.scss
// module chunks = main